<template>
  <div>
    <v-row no-gutters class="mt-16">
      <v-col cols="12" class="mt-12">
        <v-row>
          <span>ارزیابی اولیه</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="4">
            <app-date-picker label="زمان ارزیابی *" inputID="assessmentDate"
              :const-value="patientInitialAssessment.assessmentDate"
              v-model="patientInitialAssessment.assessmentDate" />
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="allConsciousnessLevelsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="سطح هوشیاری *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientInitialAssessment.consciousnessLevelId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="allAirwaysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="راه هوایی *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientInitialAssessment.airwayId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="allRespirationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="تنفس *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientInitialAssessment.respirationId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="allBloodCirculationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="گردش خون *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patientInitialAssessment.bloodCirculationId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <span>بیمار بحرانی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="4" class="mt-3">
            <span class="ciritical-text">
              آیا بیمار در ارزیابی اولیه وضعیت بحرانی Critical قرار دارد؟
            </span>
          </v-col>
          <v-col cols="3" class="mt-n2">
            <v-radio-group v-model="patientInitialAssessment.isCritical" row>
              <v-radio label="بله" :value="true"></v-radio>
              <v-radio label="خیر" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-spacer></v-spacer>
          <v-btn rounded color="darkColor" dark @click="goToStep3()">ثبت و بعدی</v-btn>
          <v-btn text color="darkColor" @click="backToStep1()">قبلی</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AppDatePicker from '@/components/app/DatePicker.vue';
import ConsciousnessLevelMixin from '@/Mixins/FollowUp/ConsciousnessLevelMixin.js';
import AirwayMixin from '@/Mixins/FollowUp/AirwayMixin.js';
import RespirationMixin from '@/Mixins/FollowUp/RespirationMixin.js';
import BloodCirculationMixin from '@/Mixins/FollowUp/BloodCirculationMixin.js';
import PatientInitialAssessmentMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientInitialAssessmentMixin.js';
import SharedMixin from '@/Mixins/Shared';
import FollowUpPatientStep2Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep2Helper.js';

export default {
  mixins: [
    ConsciousnessLevelMixin,
    AirwayMixin,
    RespirationMixin,
    BloodCirculationMixin,
    SharedMixin,
    FollowUpPatientStep2Helper,
    PatientInitialAssessmentMixin,
  ],
  components: { AppDatePicker },
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  methods: {
    mounte: function () {
      this.getPatientInitialAssessmentByIdFunction(this.patientId);
      this.getListOfConsciousnessLevelsForOther();
      this.getListOfAirwaysForOther();
      this.getListOfRespirationsForOther();
      this.getListOfBloodCirculationsForOther();
    },
  }
};
</script>
<style scoped>
.ciritical-text {
  color: #212121 !important;
}
</style>
